import React from "react";
import { Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ResponsivePage } from "../../../components/desktopUi";
import { MenuCard, MenuGrid } from "../../../components/managementUi";
import { appImages } from "../../../assets/appicons";
import { EMP_BASE_PATH } from "../../../config";

// Khớp app: app/(feature)/management/broker-debt-certificate/index.tsx
const CcmgIndex = () => {
  const navigate = useNavigate();
  return (
    <ResponsivePage title="Quản lý CCMG">
      <MenuGrid>
        <MenuCard
          icon={appImages.icon_TTKQ}
          label="Tạm giữ CCMG"
          onClick={() => navigate(`${EMP_BASE_PATH}/quan-ly/ccmg/tam-giu`)}
        />
        <MenuCard
          icon={appImages.icon_HDMB}
          label="Lịch sử thanh toán CCMG"
          onClick={() => navigate(`${EMP_BASE_PATH}/quan-ly/ccmg/thanh-toan`)}
        />
      </MenuGrid>
    </ResponsivePage>
  );
};

export default CcmgIndex;
